import React from "react";
import PropertyListing from "../components/PropertyListing";
import Seo from "../components/Seo";

const Buying = () => (
  <>
    <Seo
      title="Houses for Sale in Bath & Bristol"
      description="Browse the latest houses and flats for sale in Bath and Bristol with Anadear Estates. Book viewings, register your search and buy with local experts."
      path="/buying"
    />
    <PropertyListing
      status="for-sale"
      title="Properties for Sale"
      subtitle="Buying in Bath & Bristol"
      heroImage="https://images.unsplash.com/photo-1589806363334-42ca16a11a8a"
    />
  </>
);

export default Buying;
